import React, { ReactNode } from 'react';
import HBox from './HBox';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import styles from './Accordion.module.css';

type AccordionProps = {
  title: ReactNode;
  children: any;
  startOpen?: boolean;
};
export const Accordion = ({ title, children, startOpen }: AccordionProps) => {
  const [open, setOpen] = React.useState(startOpen || false);
  const contentId = React.useId();

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <div className={styles.container}>
      <button
        type="button"
        onClick={toggleOpen}
        className={styles.titleContainer}
        aria-expanded={open}
        aria-controls={contentId}
      >
        <HBox>
          <div>{title}</div>
          <Icon path={open ? mdiChevronDown : mdiChevronUp} size={1} />
          <div className={styles.bar} />
        </HBox>
      </button>
      <div
        id={contentId}
        className={styles.content}
        hidden={!open}
        aria-hidden={!open}
        style={{
          height: open ? 'auto' : '0',
          opacity: open ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};
